import React, {useMemo, useState} from 'react';
import DashboardLayout from "../../../layouts/DashboardLayout";
import PageHeader from "../../../components/PageHeader";
import {useTranslation} from "react-i18next";
import {GET_DOCS_V1_LIST} from "../../../utils/graphql";
import {apollo} from "../../../utils/apollo";
import {useQuery} from "react-query";
import Loading from "../../../components/Loading";

function DocsV1Index() {
	const {t} = useTranslation();
	// getDocsV1List
	const [selectedDocId, setSelectedDocId] = useState(null);

	const fetchDocs = useQuery('api_docs_v1_list', async () => {
		const {data} = await apollo.query({
			query: GET_DOCS_V1_LIST, variables: {},
		});
		return data?.getDocsV1List || null;
	}, {keepPreviousData: true});

	const records = useMemo(() => fetchDocs?.isSuccess ? fetchDocs?.data : null, [fetchDocs]);

	// Set the first item as selected when data is loaded
	useMemo(() => {
		if (records?.data?.length > 0 && !selectedDocId) {
			setSelectedDocId(records.data[0].id);
		}
	}, [records, selectedDocId]);

	// Get the selected document
	const selectedDoc = useMemo(() => {
		if (!selectedDocId || !records?.data) return null;
		return records.data.find(item => item.id === selectedDocId);
	}, [selectedDocId, records]);

	return (<DashboardLayout>
		<PageHeader title={t('api_docs.page_title')} description={t('api_docs.page_description')}></PageHeader>
		{fetchDocs.isLoading && <Loading/>}
		{fetchDocs.isSuccess && (
			<div className="mt-2 flex flex-col lg:flex-row w-full max-w-6xl">
				{/* Sidebar with document titles */}
				<div className="w-full shrink-0 lg:w-64 mb-4 lg:mb-0 lg:mr-6">
					<div className="bg-white rounded-lg shadow p-4">
						<h3 className="text-lg font-medium mb-3">{t('api_docs.contents')}</h3>
						<ul className="space-y-2">
							{records?.data?.map(item => (
								<li key={item.id}>
									<button
										onClick={() => setSelectedDocId(item.id)}
										className={`w-full text-left px-3 py-2 rounded-md text-sm font-medium transition-colors duration-150 ${
											selectedDocId === item.id
												? 'bg-blue-50 text-blue-700'
												: 'text-gray-700 hover:bg-gray-100'
										}`}
									>
										{item.name}
									</button>
								</li>
							))}
						</ul>
					</div>
				</div>

				{/* Main content area */}
				<div className="flex-1 w-full">
					{selectedDoc ? (
						<div className="bg-white rounded-lg shadow p-6">
							<h2 className="mb-6">
								<span className="bg-clip-text print:text-black text-transparent bg-gradient-to-r from-green-500 to-blue-500 font-bold text-xl">
									{selectedDoc.name}
								</span>
							</h2>
							<div className="prose w-full max-w-3xl" dangerouslySetInnerHTML={{__html: selectedDoc.html}}/>
						</div>
					) : (
						<div className="bg-white rounded-lg shadow p-6 text-gray-500">
							{t('api_docs.select_topic')}
						</div>
					)}
				</div>
			</div>
		)}
	</DashboardLayout>);
}

export default DocsV1Index;
